import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { NumericFormat } from "react-number-format";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Calendar } from "primereact/calendar";
import throttle from "lodash/throttle";
import parse from "autosuggest-highlight/parse";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import {
  locale,
  addLocale,
  updateLocaleOption,
  updateLocaleOptions,
  localeOption,
  localeOptions,
} from "primereact/api";
//import { selectedRowsCountSelector } from "@material-ui/data-grid";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/DialogDemo.css";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Tooltip,
  useMap,
  latLngBound,
} from "react-leaflet";
import "./Map.css";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";

const PREFIX = "MyCard";
const classes = {
  root: `${PREFIX}-root`,
  textField: `${PREFIX}-textField`,
  iconButton: `${PREFIX}-iconButton`,
};

const Root = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: "flex",
  },
  [`&.${classes.textField}`]: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 0,
    marginTop: 0,
    fontWeight: 500,
  },
  [`&.${classes.iconButton}`]: {
    padding: 10,
  },
}));

export default function TrasladosServicios(props) {
  //const classes = useStyles();

  addLocale("es", {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
  });

  locale("es");
  let minDate = new Date();

  const serviciosContext = useContext(ServiciosContext);
  const {
    afiliado,
    direcciones,
    servicioSeleccionado,
    trasladosServicios,
    trasladoServicio,
    trasladosServiciosPami,
    tomaAzul,
    guardarTomaAzul,
    guardarTrasladoServicio,
    obtenerDirecciones,
    obtenerTrasladosServicios,
    obtenerDestinosPami,
  } = serviciosContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { configuracion, tiposMoviles, diagnosticos, obtenerTiposMoviles } =
    configuracionContext;

  //const classes = useStyles({color: afiliado ? afiliado.motivoConsultaColor : null });

  useEffect(() => {
    //obtenerDiagnosticos({ todos: false });
    obtenerTiposMoviles();
  }, []);

  useEffect(() => {
    //obtenerNotas({ servicioId: servicio.id });
    if (servicioSeleccionado && servicioSeleccionado !== null) {
      obtenerTrasladosServicios({ servicioId: servicioSeleccionado.id });
    }
  }, [servicioSeleccionado.id]);

  useEffect(() => {
    let date = new Date();
    let newDate = new Date(date);
    newDate.setHours(date.getHours() - 3);

    if (configuracion.pami === servicioSeleccionado.titularId) {
      obtenerDestinosPami({ idPami: servicioSeleccionado.indicativoEmisor });

      guardarTrasladoServicio({
        salida: newDate.toISOString().slice(0, 16),
        destino: "",
        descripcion: "",
        lat: "",
        lon: "",
        provincia: "Buenos Aires",
        espera: null,
        medicoRecibe: null,
        retorno: false,
      });
    } else {
      if (trasladosServicios && trasladosServicios.length === 0) {
        guardarTrasladoServicio({
          salida:
            servicioSeleccionado.movilId < 1000
              ? newDate.toISOString().slice(0, 16)
              : null,
          destino:
            servicioSeleccionado && servicioSeleccionado.traslados
              ? servicioSeleccionado.traslados.destino
              : null,
          descripcion: "",
          lat: "",
          lon: "",
          provincia: "Buenos Aires",
          /*
          espera:
            trasladosServicios && servicioSeleccionado.movilId < 1000
              ? calcularEsperaMinutos(convertDate(new Date()))
              : null,
          */
          espera: null,    
          medicoRecibe: null,
          retorno: false,
        });
      } else {
        guardarTrasladoServicio({
          salida:
            servicioSeleccionado.movilId < 1000
              ? newDate.toISOString().slice(0, 16)
              : null,
          destino: "",
          descripcion: "",
          lat: "",
          lon: "",
          provincia: "Buenos Aires",
          /*
          espera:
            trasladosServicios && servicioSeleccionado.movilId < 1000
              ? calcularEsperaMinutos(convertDate(new Date()))
              : null,
          */
          espera: null,    
          medicoRecibe: null,
          retorno: false,
        });
      }
    }
    let campo = document.getElementById("provincia");
    if (campo) {
      campo.focus();
    }
  }, [trasladosServicios]);

  //Dialog

  //const theme = useTheme();
  //const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Leer tecla y foco

  function handleEnter(event) {
    if (event.keyCode === 13) {
      let element = event.target.id;
      let campo = null;

      switch (element) {
        case "llegada":
          campo = document.getElementById("provincia");
          campo.focus();
          break;
        case "provincia":
          if (configuracion.pami === servicioSeleccionado.titularId) {
            campo = document.getElementById("destinoPami");
            campo.focus();
            break;
          } else {
            campo = document.getElementById("destino");
            campo.focus();
            break;
          }
        case "destino":
          campo = document.getElementById("destinoGeo");
          campo.focus();
          break;
        case "destinoPami":
          campo = document.getElementById("destinoGeo");
          campo.focus();
          break;
      }
    }

    if (event.keyCode === 27) {
      let element = event.target.id;
      let campo = null;

      switch (element) {
        case "destinoGeo":
          if (configuracion.pami === servicioSeleccionado.titularId) {
            campo = document.getElementById("destinoPami");
            campo.focus();
            break;
          } else {
            campo = document.getElementById("destino");
            campo.focus();
            break;
          }
        case "destino":
          campo = document.getElementById("provincia");
          campo.focus();
          break;
        case "destinoPami":
          campo = document.getElementById("provincia");
          campo.focus();
          break;
        case "provincia":
          campo = document.getElementById("llegada");
          campo.focus();
          break;
      }
    }
  }

  const renderHeaderMapa = () => {
    return (
      <div>
        <Tag value="Ubicación en el Mapa"></Tag>
      </div>
    );
  };

  const renderFooterMapa = () => {
    return (
      <div>
        <Button
          label="Cerrar"
          icon="pi pi-times"
          onClick={() => handleClose()}
          className="p-button-text"
        />
      </div>
    );
  };

  function convertDate(today) {
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    var hh = String(today.getHours()).padStart(2, "0");
    var mi = String(today.getMinutes()).padStart(2, "0");

    return dd + "/" + mm + "/" + yyyy + " " + hh + ":" + mi;
  }

  function PopupExample(e) {
    if (
      trasladoServicio === undefined ||
      trasladoServicio === null ||
      trasladoServicio.lat === undefined ||
      trasladoServicio.lat === null ||
      trasladoServicio.lon === undefined ||
      trasladoServicio.lon === null
    ) {
      return;
    }

    let position = [];
    position.push(trasladoServicio.lat);
    position.push(trasladoServicio.lon);

    return (
      <MapContainer
        center={position}
        zoom={15}
        style={{ height: "60vh", width: "60vh" }}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}></Marker>
      </MapContainer>
    );
  }

  function clearLocalidad() {
    guardarTrasladoServicio({
      ...trasladoServicio,
      localidad: "",
    });
  }

  const handleInputBlur = (event) => {
    clearLocalidad();
    obtenerDirecciones({
      domicilio: trasladoServicio.destino.toLowerCase(),
      provincia: trasladoServicio.provincia.toLowerCase(),
    });
  };

  /*
  function calcularEsperaMinutos(tiempo) {
    let n = tiempo.search("T");
    let time = null;
    let time2 = null;
    let diferenciaEnMinutos = null;
    if (n === -1) {
      time =
        tiempo.substring(6, 10) +
        "-" +
        tiempo.substring(3, 5) +
        "-" +
        tiempo.substring(0, 2) +
        "T" +
        tiempo.substring(11, 16);
    } else {
      time = tiempo;
    }
    let nuevo = new Date(time);

    nuevo.setHours(nuevo.getHours() - 3);
    nuevo = nuevo.toISOString().substring(0, 16);

    if (trasladosServicios.length === 0) {
      time2 =
        servicioSeleccionado.llegada.substring(6, 10) +
        "-" +
        servicioSeleccionado.llegada.substring(3, 5) +
        "-" +
        servicioSeleccionado.llegada.substring(0, 2) +
        "T" +
        servicioSeleccionado.llegada.substring(11, 16);

      let nuevo2 = new Date(time2);

      nuevo2.setHours(nuevo2.getHours() - 3);
      nuevo2 = nuevo2.toISOString().substring(0, 16);
      diferenciaEnMinutos = (new Date(nuevo) - new Date(nuevo2)) / 60000;
    } else {
      let index = trasladosServicios.length - 1;

      time2 = trasladosServicios[index].llegada;
      let nuevo2 = new Date(time2);

      //nuevo2.setHours(nuevo2.getHours() + 3);
      nuevo2 = nuevo2.toISOString().substring(0, 16);
      diferenciaEnMinutos = (new Date(nuevo) - new Date(nuevo2)) / 60000;
    }

    return diferenciaEnMinutos;
  }
  */


  //console.log(trasladoServicio);
  //console.log(trasladosServicios);
  //console.log(servicioSeleccionado);

  return (
    <Root className={classes.root}>
      <Fragment>
        {trasladoServicio && trasladosServicios && servicioSeleccionado ? (
          <Grid
            container
            spacing={3}
            style={{ padding: "0", marginTop: "1vw" }}
          >
            <Grid item xs={12} md={6}>
              {servicioSeleccionado.movilId < 1000 ? (
                <Fragment>
                  <TextField
                    id="salida"
                    label="Salida"
                    noOptionsText={"No hay opciones"}
                    defaultValue={convertDate(new Date())}
                    className={classes.textField}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={true}
                  />
                </Fragment>
              ) : (
                <TextField
                  id="salida"
                  label="Salida"
                  type="datetime-local"
                  //noOptionsText={"No hay opciones"}
                  defaultValue={null}
                  className={classes.textField}
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    guardarTrasladoServicio({
                      ...trasladoServicio,
                      salida: e.target.value,
                      espera: null,
                      /*
                      espera: trasladosServicios
                        ? calcularEsperaMinutos(e.target.value)
                        : null,
                      */  
                    });
                  }}
                />
              )}
            </Grid>
            {configuracion &&
            configuracion.pami === servicioSeleccionado.titularId &&
            trasladosServiciosPami &&
            (servicioSeleccionado.color === "VERDE" ||
              servicioSeleccionado.color === "AMARILLO" ||
              servicioSeleccionado.color === "ROJO") ? (
              <Fragment>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="provincia"
                    label="Provincia"
                    value={trasladoServicio ? trasladoServicio.provincia : null}
                    required
                    fullWidth
                    variant="standard"
                    size="small"
                    className={classes.textField}
                    onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarTrasladoServicio({
                        ...trasladoServicio,
                        provincia: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Autocomplete
                    id="destinoPami"
                    fullWidth
                    disablePortal
                    noOptionsText={"No hay opciones"}
                    options={trasladosServiciosPami}
                    getOptionLabel={(option) => option.destino}
                    openOnFocus={true}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Destinos PAMI"
                        variant="standard"
                      />
                    )}
                    onKeyDown={handleEnter}
                    onBlur={(e) => handleInputBlur(e)}
                    onChange={(event, value) => {
                      if (value) {
                        guardarTrasladoServicio({
                          ...trasladoServicio,
                          destino: value.destino,
                          descripcion: value.descripcion,
                          lat: null,
                          lon: null,
                        });
                      } else {
                        guardarTrasladoServicio({
                          ...trasladoServicio,
                          destino: null,
                          descripcion: "",
                          lat: null,
                          lon: null,
                        });
                      }
                    }}
                  />
                </Grid>
              </Fragment>
            ) : (
              <Fragment>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="provincia"
                    label="Provincia"
                    value={trasladoServicio ? trasladoServicio.provincia : null}
                    required
                    fullWidth
                    variant="standard"
                    size="small"
                    className={classes.textField}
                    onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarTrasladoServicio({
                        ...trasladoServicio,
                        provincia: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{ paddingLeft: ".5EM", marginTop: "0.8em" }}
                >
                  <FormControlLabel
                    value="yes"
                    control={
                      <Checkbox
                        id="retorno"
                        color="primary"
                        checked={
                          trasladoServicio ? trasladoServicio.retorno : false
                        }
                        //onKeyDown={handleEnter}
                        onChange={(e) => {
                          if (e.target.checked) {
                            guardarTrasladoServicio({
                              ...trasladoServicio,
                              retorno: e.target.checked,
                              destino: servicioSeleccionado.domicilio,
                            });
                          } else {
                            guardarTrasladoServicio({
                              ...trasladoServicio,
                              retorno: e.target.checked,
                              destino: "",
                            });
                          }
                        }}
                      />
                    }
                    disabled={
                      servicioSeleccionado &&
                      servicioSeleccionado.traslados &&
                      servicioSeleccionado.traslados.retorno
                    }
                    label="Retorno"
                    labelPlacement="start"
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    id="destino"
                    label="Destino"
                    value={trasladoServicio ? trasladoServicio.destino : null}
                    fullWidth
                    variant="standard"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={classes.textField}
                    onKeyDown={handleEnter}
                    onBlur={(e) => handleInputBlur(e)}
                    onChange={(e) =>
                      guardarTrasladoServicio({
                        ...trasladoServicio,
                        destino: e.target.value,
                      })
                    }
                  />
                </Grid>
              </Fragment>
            )}

            <Grid item xs={12} md={11}>
              <Autocomplete
                id="destinoGeo"
                fullWidth
                disablePortal
                noOptionsText={"No hay opciones"}
                options={direcciones}
                getOptionLabel={(option) => option.label}
                openOnFocus={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Destino Geolocalizado"
                    variant="standard"
                  />
                )}
                onKeyDown={handleEnter}
                onChange={(event, value) => {
                  if (value) {
                    guardarTrasladoServicio({
                      ...trasladoServicio,
                      destinoGeo: value.label,
                      lat: value.lat,
                      lon: value.lon,
                    });
                  } else {
                    guardarTrasladoServicio({
                      ...trasladoServicio,
                      destinoGeo: null,
                      lat: null,
                      lon: null,
                    });
                  }
                }}
              />
            </Grid>

            <Grid item xs={4} md={1}>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
                onClick={(e) => handleClickOpen()}
              >
                <SearchIcon />
              </IconButton>
            </Grid>

            <div className="dialog-demo">
              <Dialog
                header={renderHeaderMapa()}
                visible={open}
                footer={renderFooterMapa()}
                closable={false}
              >
                {PopupExample()}
              </Dialog>
            </div>

            {/*    
            <Grid item xs={12} md={3}>
              <NumericFormat
                {...props}
                id="espera"
                label="Espera en minutos"
                customInput={TextField}
                format="###"
                type="numeric"
                fullWidth
                variant="standard"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                value={trasladoServicio ? trasladoServicio.espera : 0}
                onKeyDown={handleEnter}
                onChange={(e) =>
                  guardarTrasladoServicio({
                    ...trasladoServicio,
                    espera: e.target.value,
                  })
                }
              />
            </Grid>
            */}

            <Grid item xs={12} md={9}>
              <TextField
                id="medicoRecibe"
                label="Médico Recibe"
                value={trasladoServicio ? trasladoServicio.medicoRecibe : null}
                fullWidth
                variant="standard"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                onKeyDown={handleEnter}
                //onBlur={(e) => handleInputBlur(e)}
                onChange={(e) =>
                  guardarTrasladoServicio({
                    ...trasladoServicio,
                    medicoRecibe: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={12} md={12}></Grid>
          </Grid>
        ) : null}
      </Fragment>
    </Root>
  );
}
